console.log('✅ Event Listener Registry loaded to-attach-event-listener-registry.js.');

const attachEventListenerRegistry = [];

// this is used by the master page once it finishes building a page

export function registerEventListenerToAttach(listenerFn) {
  if (typeof listenerFn !== 'function') {
    console.warn('⚠️ Tried to register a non-function as an event listener.');
    return;
  }

  if (attachEventListenerRegistry.includes(listenerFn)) {
    console.warn('⚠️ Listener already registered, skipping duplicate.');
    return;
  }

  attachEventListenerRegistry.push(listenerFn);
  console.log('🔧 Registered event listener.');
}

//export function registerEventListenerToAttach(listenerFn) {
//    if (typeof listenerFn === "function") {
//        attachEventListenerRegistry.push(listenerFn);
//        console.log("🔧 Registered event listener.");
//    } else {
//        console.warn("⚠️ Tried to register a non-function as an event listener.");
//    }
//}

/**
 * Execute all registered event listeners after the final rendering
 */
export function executeRegisteredAttachEventListeners() {
  console.log('🚀 Attaching registered event listeners...');
  attachEventListenerRegistry.forEach((listenerFn, index) => {
    try {
      listenerFn();
      console.log(`✅ Event listener ${index + 1} executed.`);
    } catch (error) {
      console.error(`❌ Error executing listener ${index + 1}:`, error);
    }
  });
  // Clear the registry to prevent duplicate calls
  attachEventListenerRegistry.length = 0;
}
